/**
 * ContentContainer module
 *
 * This module is a container of content
 *
 */

'use strict';

const _ = require('lodash');

let AbstractContent = require('./../model/AbstractContent');

let ContentContainer = {};
let container = {};

/**
 * Add an element
 *
 * @param {object} element
 * @returns {object} Content container
 */
ContentContainer.add = function(element) {
    if (!(element instanceof AbstractContent)) {
        throw new Error('Element must be an instance of AbstractContent');
    }

    container[element.id] = element;

    return this;
};

/**
 * Remove an element
 *
 * @param  {object | string} element
 * @returns {object} Content container
 */
ContentContainer.remove = function(element) {
    if (!element) {
        throw new Error('You must set the element or the id to remove');
    }

    let id = _.isString(element) ? element : element.id;

    if (container[id]) {
        delete container[id];
    }

    return this;
};

/**
 * Retrieve content by id
 *
 * @param {string} id
 * @returns {object} elements
 */
ContentContainer.get = function(id) {
    return container[id] || null;
};

/**
 * Retrieve all contents
 *
 * @returns {object} elements
 */
ContentContainer.getAll = function() {
    return container;
};

/**
 * Clear all contents
 *
 * @returns {object} Content container
 */
ContentContainer.clear = function() {
    container = {};

    return this;
};

module.exports = ContentContainer;
